import styled from 'styled-components'
import {ReactComponent as HappyIcon} from '../NewsletterModalInner/happy_face.svg'

export const Container = styled.div`
  color: #000;
  max-width: 28rem;
  margin: 0 auto;
`
export const Happy = styled(HappyIcon)`
  fill: ${(props) => props.bgColor};
`

export const SuccessContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem auto;
  text-align: center;
`
